import { addons } from "@storybook/addons";
import nitecoTheme from "./nitecoTheme";

addons.setConfig({
	isFullscreen: true,
	showNav: true,
	showPanel: true,
	panelPosition: "right",
	enableShortcuts: true,
	showToolbar: true,
	theme: nitecoTheme,
	selectedPanel: undefined,
	initialActive: "sidebar",
	sidebar: {
		showRoots: true,
		collapsedRoots: ["other"],
	},
	toolbar: {
		title: { hidden: false },
		zoom: { hidden: false },
		eject: { hidden: false },
		copy: { hidden: false },
		fullscreen: { hidden: false },
	},
});
